const BranchWiseFetchDetailsTypes = {
	/** ****************************** BRANCH WISE FETCH *********************** */
	BRANCH_WISE_FETCH_START: 'branch_wise_fetch_start',
	BRANCH_WISE_FETCH_SUCCESS: 'branch_wise_fetch_success',
	BRANCH_WISE_FETCH_FAILURE: 'branch_wise_fetch_failure',
	BRANCH_WISE_FETCH_RESPONSE_CHANGED: 'branch_wise_fetch_response_changed',
	BRANCH_WISE_FETCH_RESPONSE_REST_START: 'branch_wise_fetch_response_rest_start',
};

export default BranchWiseFetchDetailsTypes;
